import {
  PhoneCallIcon,
  SearchCheckIcon,
  CalendarCheckIcon,
  HardHatIcon,
  ClipboardListIcon,
  HandshakeIcon,
} from 'lucide-react'
import type { ProcessStep } from '../types/content'

export const processSteps: ProcessStep[] = [
  {
    icon: PhoneCallIcon,
    title: { en: 'Contact & Consultation', es: 'Contacto y Consulta' },
    description: {
      en: 'Call, text on WhatsApp or send the form. We listen to what you need and answer in your language — free, no pressure.',
      es: 'Llama, escribe por WhatsApp o envía el formulario. Escuchamos lo que necesitas y respondemos en tu idioma — gratis y sin presión.',
    },
  },
  {
    icon: SearchCheckIcon,
    title: { en: 'Site Inspection & Quote', es: 'Inspección y Presupuesto' },
    description: {
      en: 'We measure on site, flag anything hidden, and give you a written line-item quote with no surprises later.',
      es: 'Medimos en sitio, señalamos cualquier problema oculto y entregamos un presupuesto escrito y detallado, sin sorpresas.',
    },
  },
  {
    icon: CalendarCheckIcon,
    title: { en: 'Schedule & Preparation', es: 'Agenda y Preparación' },
    description: {
      en: 'You pick the dates. We protect floors, furniture and fixtures before a single tool comes out.',
      es: 'Tú eliges las fechas. Protegemos pisos, muebles y accesorios antes de empezar a trabajar.',
    },
  },
  {
    icon: HardHatIcon,
    title: { en: 'Professional Execution', es: 'Ejecución Profesional' },
    description: {
      en: 'Our crew works clean, on schedule, and keeps you updated daily with photos of progress.',
      es: 'Nuestro equipo trabaja limpio, a tiempo, y te mantiene informado a diario con fotos del progreso.',
    },
  },
  {
    icon: ClipboardListIcon,
    title: { en: 'Quality Inspection', es: 'Inspección de Calidad' },
    description: {
      en: 'We walk the job with you, punch-list every detail, and correct it before we call it finished.',
      es: 'Recorremos el trabajo contigo, anotamos cada detalle y lo corregimos antes de dar el trabajo por terminado.',
    },
  },
  {
    icon: HandshakeIcon,
    title: { en: 'Satisfaction & Follow-up', es: 'Satisfacción y Seguimiento' },
    description: {
      en: 'Warranty in writing and a follow-up call after you have lived with the work for a few weeks.',
      es: 'Garantía por escrito y una llamada de seguimiento después de que hayas disfrutado el trabajo unas semanas.',
    },
  },
]
